import { Color } from './types'

export const getColorById = (colors: Color[], id: string): string | undefined => {
  const color = colors?.find((color: Color) => color.id === id)
  return color?.color_value
}
